function rights (list, name, access) {
  return list.filter(perm => perm.module.name === name)
    .some(p => access.includes(p.rule.name))
}

function rightForID (list, module, ruleName, id) {
  const perConfigRule = list.find(mod =>
    mod.module.name === module &&
    mod.rule.name === `${ruleName}_for` &&
    ~~mod.value === id)
  return perConfigRule !== undefined
}

function rightFor (list, module, ruleName, id) {
  const mod = list.filter(perm => perm.module.name === module)
  if (!mod.length) {
    return false
  }
  const rule = list.find(mod => mod.rule.name === ruleName)
  // global can
  if (rule !== undefined) {
    return true
  }
  return rightForID(list, module, ruleName, id)
}

// list is used as an alternative to read_for when read_for already exists and we need another target ID
export function canRead (list, name, id) {
  if (id) {
    return rightForID(list, name, 'read', id)
  }
  return rights(list, name, ['read', 'read_for', 'list_for'])
}

export function canWrite (list, name, id) {
  if (id) {
    return rightForID(list, name, 'write', id)
  }
  return rights(list, name, ['write'])
}

// manage: read + write for sub features
export function canManage (list, module, ruleName) {
  const rule = `manage_${ruleName}`
  return rights(list, module, [rule])
}

export function canExec (list, module, ruleName, id) {
  const rule = `execute_${ruleName}`
  return rightFor(list, module, rule, id)
}

export function canShow (list, module, ruleName, id) {
  const rule = `show_${ruleName}`
  return rightFor(list, module, rule, id)
}
